<span class="notification" matSnackBarLabel>
  <div class="icon-text">
    <ng-container *ngIf="data.icon">
      <mat-icon>{{ data.icon }}</mat-icon>
    </ng-container>
    <div class="text">
      <ng-container *ngIf="data.title">
        <p>{{ data.title }}</p>
      </ng-container>
      <ng-container *ngIf="data.description">
        <p>{{ data.description }}</p>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="data.action">
    <button
      mat-flat-button
      matSnackBarAction
      [color]="getButtonColor(data.panelClass)"
      (click)="snackBarRef.dismissWithAction()"
    >
      {{ data.action }}
    </button>
  </ng-container>
</span>
